// Tracks what the user searches/asks for, purely client-side (localStorage),
// so the AI popup can surface "what you often look for" suggestions without
// any backend involvement.
const STORAGE_KEY = 'corpintel_query_history';
const MAX_ENTRIES = 200;

function readHistory() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function recordQuery(text) {
  const trimmed = (text || '').trim();
  if (trimmed.length < 3) return;
  const history = readHistory();
  history.push({ text: trimmed, ts: Date.now() });
  const capped = history.slice(-MAX_ENTRIES);
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(capped));
  } catch {
    // localStorage unavailable (private mode etc) - fail silently, not critical
  }
}

export function clearHistory() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // localStorage unavailable - nothing to clear anyway
  }
}

export function getFrequentQueries(limit = 5) {
  const history = readHistory();
  const counts = new Map();
  for (const { text } of history) {
    const key = text.toLowerCase();
    const entry = counts.get(key) || { text, count: 0 };
    entry.count += 1;
    counts.set(key, entry);
  }
  return Array.from(counts.values())
    .sort((a, b) => b.count - a.count)
    .slice(0, limit)
    .map(e => e.text);
}

export function getRecentQueries(limit = 8) {
  const history = readHistory();
  return history.slice(-limit).reverse().map(h => h.text);
}
